import React from "react";

 function NoDataFounded () {
    return(
        <p className="text-center text-primary">No Data Found</p>
    )
}

export default  NoDataFounded